<template>
  <div
    class="card mb-3 border-0 shadow-sm custom-branch-card"
    :class="{'border-theme': branch.is_active}"
    :key="branch.branch_id"
  >
    <div class="bg-white border-bottom-0 card-header d-flex justify-content-between rounded-bottom">
      <div class="d-flex align-items-center">
        <div class="branch-icon me-3" :class="branch.is_active ? 'bg-theme text-white' : 'bg-light text-muted'">
          <i class="fa-solid fa-shop"/>
        </div>
        <div>
          <h6 class="mb-0 fw-bold" :class="{'text-theme': branch.is_active}">{{ branch.name }}</h6>
          <small class="text-muted" v-if="branch.code">{{ $t('Code') + ': ' + branch.code }}</small>
        </div>
      </div>
      <div class="form-check form-switch ms-3">
        <input
          class="form-check-input shadow-none"
          type="checkbox"
          v-model.trim="v$.branch.is_active.$model"
        >
      </div>
    </div>

    <div class="card-body bg-white pt-0 rounded-bottom" v-if="branch.is_active">
      <hr class="mt-0 mb-3 text-black-50">

      <div class="row g-2 align-items-end" :class="{'mb-3': baseForm.is_config}">
        <div v-if="!baseForm.is_config" class="col-md-7">
          <label class="form-label small fw-semibold text-muted">{{ $t('Branch Price') }}</label>

          <div v-if="!branch.is_custom_price" class="d-flex align-items-center">
            <div class="bg-light border px-3 py-1 rounded small text-muted me-2 d-flex justify-content-between align-items-center" style="flex-grow: 1;">
              <span>{{ $t('Standard') }}:</span>
              <span class="text-dark fw-bold">{{ baseForm.price }} {{ $t('฿') }}</span>
            </div>
            <button
              type="button"
              class="btn btn-sm btn-light border text-theme py-1 textnowrap"
              @click="branch.is_custom_price = true;"
            >
              <i class="fa-solid fa-pen-to-square"/> {{ $t('Edit') }}
            </button>
          </div>

          <div v-else class="d-flex align-items-center">
            <div class="input-group input-group-sm custom-input-group me-2">
              <input
                type="number"
                inputmode="decimal"
                class="form-control shadow-none text-end text-theme fw-bold"
                v-model.trim="v$.branch.price_override.$model"
                :placeholder="baseForm.price"
              >
              <span class="input-group-text bg-light border-0">{{ $t('฿') }}</span>
            </div>
            <button type="button" class="btn btn-sm btn-light border text-danger py-1 px-2"
              @click="branch.is_custom_price = false; branch.price_override = ''"
            >
              <i class="fa-solid fa-rotate-left"/>
            </button>
          </div>
        </div>

        <div :class="baseForm.is_config ? 'col-md-6' : 'col-md-5'">
          <label class="form-label small fw-semibold text-muted">
            {{ baseForm.is_config ? $t('Overall Stock Status') : $t('Stock Status') }}
          </label>
          <select
            class="form-select form-select-sm shadow-none"
            v-model.trim="v$.branch.is_in_stock.$model"
          >
            <option :value="true">{{ $t('In Stock') }}</option>
            <option :value="false">{{ $t('Out of Stock') }}</option>
          </select>
        </div>
      </div>

      <div v-if="baseForm.is_config" class="mt-2 pt-3 border-top">
        <label class="form-label small fw-semibold text-muted mb-2">{{ $t('Variant Pricing for this Branch') }}</label>
        <div class="table-responsive border rounded">
          <table class="table table-sm table-hover mb-0 align-middle">
            <thead class="table-light">
              <tr>
                <th style="min-width: 180px;">{{ $t('Variant') }}</th>
                <th class="text-end" style="min-width: 150px;">{{ $t('Price') }} ({{ $t('฿') }})</th>
                <th class="text-center" style="min-width: 150px;">{{ $t('Stock Status') }}</th>
              </tr>
            </thead>
            <tbody>
              <template
                v-for="(variant, vIndex) in branch.variants"
              >
                <item-manage-branch-variant-form
                  :base-is-in-stock="branch.is_in_stock"
                  :variant="variant"
                  :index="vIndex"
                />
              </template>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import AccessDenied from "@/plugins/AccessDenied.vue";
import ItemManageBranchVariantForm from './ItemManageBranchVariantForm.vue';
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation-branch-item";
import Ladda from '@/plugins/Ladda.vue';
import Popper from "vue3-popper";

export default {
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return validation(this.branch);
  },
  props: {
    branch: {
      type: Object,
      default: {}
    },
    index: {
      type: Number,
      required: true
    },
    baseForm: {
      type: Object,
      default: {}
    }
  },
  components: {
    PlaceholderContent,
    AccessDenied,
    ItemManageBranchVariantForm,
    Ladda,
    Popper
  },
  data() {
  }
}
</script>
